import { safeFetch } from "./client";
import type { CostEstimate } from "../types";

export interface EstimateEmailMeta {
  id: string;
  subject?: string;
  bodyLength: number;
  attachmentCount?: number;
  attachmentTotalChars?: number;
}

export interface EstimateCheckMeta {
  id: string;
  model?: string;
  outTok?: number;
  promptLength?: number;
}

export interface EstimateRequest {
  emails: EstimateEmailMeta[];
  checkBundle: { checks: EstimateCheckMeta[] };
}

export async function postEstimate(
  req: EstimateRequest,
): Promise<CostEstimate | null> {
  const r = await safeFetch<{ ok: boolean; estimate: CostEstimate }>(
    "/estimate",
    { method: "POST", body: JSON.stringify(req) },
  );
  return r?.estimate ?? null;
}
